/** Små DOM-hjælpere så resten af koden bliver kortere at læse. */

export const $  = (sel, root = document) => root.querySelector(sel);
export const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];

export const on = (el, evt, fn, opts) => el && el.addEventListener(evt, fn, opts);

export const show = (el, cls = 'is-visible') => el && el.classList.add(cls);
export const hide = (el, cls = 'is-visible') => el && el.classList.remove(cls);

export const lockScroll   = () => { document.body.style.overflow = 'hidden'; };
export const unlockScroll = () => { document.body.style.overflow = ''; };

/** Escaper tekst så brugerinput ikke kan injicere HTML */
export const esc = (str = '') =>
  String(str).replace(/[&<>"']/g, c =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])
  );
